const categories = {
  resources: {
    id: 0,
    name: 'Resource',
  },
  blogArticle: {
    id: 1,
    name: 'Blog Article',
  },
  openSource: {
    id: 2,
    name: 'Open Source Project',
  },
  experiments: {
    id: 3,
    name: 'Experiments',
  },
};

export default categories;



// WEBPACK FOOTER //
// ./src/configs/pages/labs/categories.js